import React, { Component } from "react";
import ContentWrapper from "../../../Layout/ContentWrapper";

import { Container, Card, CardHeader, CardBody, CardTitle, Button } from "reactstrap";
import Moment from 'moment'
import ReactDatatable from '@ashvin27/react-datatable';
import { AuthService, FarmersService,CustomerService } from '../../../../services';
import { Redirect } from 'react-router-dom';

class PostPaidCustomers extends Component {
  state = {
    customersList: [],
    loading: true
  };

  componentDidMount() {
    const isAuthenticated = AuthService.isAuthenticated();
    if (!isAuthenticated) {
      this.setState({ redirect: "/login" })
    }

    CustomerService.getAllCustomersPostPaid().then(res => {
      this.setState({ loading: false })
      this.setState({ customersList: res.data })
    })
  }

  formatDate = (date) => {
    return Moment(date).format('lll')
  }

  ViewCustomerDetails = (row) => {
    return this.props.history.push('/admin-customer-details/' + row.id, row)
  }

  AddFarmer=()=>{
    return this.props.history.push("/admin-add-farmer");
  }
  ViewAllCustomers=()=>{
    return this.props.history.push("/admin-customers");
  }


  AddActionButtonStyle = {
    color: 'white',
    background: "#003366"
  }

  config = {
    page_size: 10,
    length_menu: [10, 25, 50],
    show_filter: true,
    show_pagination: true,
    pagination: 'advance',
    filename: "Contact List",
    button: {
      // excel: true,
      // print: true,
      // csv: true
    },
    language: {
      loading_text: "Please be patient while data loads..."
    }
  }

  ucFirst = (str) => {
    if (!str) return str;
    if (str.trim() == "undefined") return "";
    return str[0].toUpperCase() + str.slice(1);
  }



  columns = [
    {
      key: "id",
      text: "#",
      sortable: true,
      cell: (record, index) => {
        return index + 1;
      }
    },
    {
      key: "fullName",
      text: "CUSTOMER NAME"
    },
    {
      key: "email",
      text: "EMAIL"
    },
    {
      key: "phoneNumber",
      text: "PHONE NUMBER",
    },
    {
      key: "customerType",
      text: "TYPE",
    },
    {
      key: "paymentType",
      text: "PAYMENT",
    },
    {
      key: "isApproved",
      text: "STATUS",
      cell: (record, index) => {
        if (record.isApproved == 1) {
          return (<span className="badge badge-success">Approved</span>)
        }
        if (record.isApproved == 2) {
          return (<span className="badge badge-danger">Rejected</span>)
        }
        if (record.isApproved == 0) {
          return (<span className="badge badge-warning">Pending</span>)
        }
      }
    },
    {
      key: "createdAt",
      text: "DATE REGISTERED",
      sortable: true,
      cell: (record, index) => {
        return (this.formatDate(record.createdAt))
      }
    },
    {
      key: "id",
      text: "ACTION",
      cell: (record, index) => {
        return (
          <Button style={{
            color: 'white',
            background: "#003366"
          }} className="btn btn-success"
            onClick={() => {
              this.ViewCustomerDetails(record);
            }}
          >
            <i className="fa fa-eye"></i>
          </Button>
        );
      }
    }

  ];


  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />
    }
    return (
      <ContentWrapper>
        <div className="content-heading">
          <div className="mr-auto flex-row">
            Post Paid Customers List
            <small>Showing all customers.</small>
          </div>
          <div className="flex-row">
            <Button onClick={this.ViewAllCustomers} style={this.AddActionButtonStyle} className="btn-pill-right">
              <i className="fa fa-eye mr-2"></i>
              View All Customers </Button>
          </div>
        </div>
        <Container fluid>
          <Card>
            <CardHeader>
            </CardHeader>
            <CardBody>

              <ReactDatatable
                extraButtons={this.extraButtons}
                config={this.config}
                records={this.state.customersList}
                columns={this.columns}
                loading={this.state.loading}

              />
            </CardBody>
          </Card>
        </Container>
      </ContentWrapper>
    );
  }
}

export default PostPaidCustomers;
